<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-fournisseur-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="fournisseurForm" @submit="editFournisseur" :validation-schema="fournisseurSchema" :initial-values="fournisseurForm">
            <div class="row">
              <div class="col-md-4 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                 Statut<span class="text-danger">*</span>
                </label>
                <Field  name="statut" v-model="defaultStatut"  v-slot="{ field }">
                  <Multiselect
                    :options="statut"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner le statut"
                    @select="handleObjetInput"
                  />
                </Field>  
              </div>
              <ErrorMessage name="statut" class="text-danger"/>
            </div>
            <div class="col-md-4 mb-3" v-if="showAdditionalFields">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Nom du fournisseur <span class="text-danger">*</span>
                </label>
                <Field name="nomFournisseur" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom"/>
                <ErrorMessage name="nomFournisseur" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4 mb-3" v-if="showAdditionalFields">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Prénom du fournisseur<span class="text-danger">*</span>
                </label>
                <Field name="prenomFournisseur" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le prenom"/>
                <ErrorMessage name="prenomFournisseur" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4 mb-3" v-if="!showAdditionalFields">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Sigle <span class="text-danger">*</span>
                </label>
                <Field name="sigle" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le sigle"/>
                <ErrorMessage name="sigle" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4 mb-3" v-if="!showAdditionalFields">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Dénomination <span class="text-danger">*</span>
                </label>
                <Field name="denomination" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la denomination"/>
                <ErrorMessage name="denomination" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4 mb-3" v-if="!showAdditionalFields">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Raison sociale <span class="text-danger">*</span>
                </label>
                <Field name="raisonSociale" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la raison sociale"/>
                <ErrorMessage name="raisonSociale" class="text-danger"/>
              </div>
            </div>
           <div class="col-md-4 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  IFU <span class="text-danger" v-if="!showAdditionalFields">*</span>
                </label>
                <Field name="ifu" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'ifu"/>
                <ErrorMessage name="ifu" class="text-danger"/>
              </div>
            </div>
            
            <div class="col-md-4 mb-3" v-if="!showAdditionalFields">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Régistre de commerce <span class="text-danger">*</span>
                </label>
                <Field name="rccm" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le régistre de commerce"/>
                <ErrorMessage name="rccm" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Adresse 
                </label>
                <Field name="adresseFournisseur" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'adresse"/>
                <ErrorMessage name="adresseFournisseur" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Email
                </label>
                <Field name="email" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'email"/>
                <ErrorMessage name="email" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4 mb-3" v-if="showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Sexe <span class="text-danger">*</span>
              </label>
              <Field  name="sexe"  type="text"  v-slot="{ field }">
                <Multiselect
                  :searchable = "true"
                  :options = "['Masculin', 'Féminin']"
                  v-model = "field.value"
                  v-bind = "field"
                  placeholder="Sélectionner le sexe"
                />
              </Field>
                <ErrorMessage name="sexe" class="text-danger"/>
            </div>
          </div>
            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Téléphone 1 <span class="text-danger">*</span>
                </label>
                <Field name="telFournisseur1" v-model="telFournisseur1"  v-slot="{ field }">
                  <vue-tel-input
                    placeholder="Entrer le numéro de téléphone"
                    v-model = "field.value"
                    v-bind = "field"
                    defaultCountry="BJ"
                    mode="international"
                    @validate="validate"
                    class ="shadow-none fs-md-15 text-black py-2">
                  </vue-tel-input>
                </Field>
                <div v-if="!validPhone"  class="text-danger">Veuillez entrer un numéro correcte</div>
                <!-- <Field name="telFournisseur1" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le téléphone"/> -->
                <ErrorMessage name="telFournisseur1" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Téléphone 2 
                </label>
                <Field name="telFournisseur2" v-model="telFournisseur2"  v-slot="{ field }">
                  <vue-tel-input
                    placeholder="Entrer le numéro de téléphone"
                    v-model = "field.value"
                    v-bind = "field"
                    defaultCountry="BJ"
                    mode="international"
                    @validate="validate"
                    class ="shadow-none fs-md-15 text-black py-2">
                  </vue-tel-input>
                </Field>
                <div v-if="!validPhone"  class="text-danger">Veuillez entrer un numéro correcte</div>
                <!-- <Field name="telFournisseur2" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le téléphone"/> -->
                <ErrorMessage name="telFournisseur2" class="text-danger"/>
              </div>
            </div>
            
            <div class="col-md-4" v-if="!showAdditionalFields">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de création 
                  </label>
                  <Field name="dateCreation" type="date" :max="currentDate"
                  class="form-control shadow-none fs-md-15 text-black"/>
                </div>
              <ErrorMessage name="dateCreation" class="text-danger"/>
              </div>
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button class="btn btn-success me-3" type="submit">
                  Modifier un fournisseur
              </button>
              <router-link to="/fournisseurs/liste-fournisseurs" 
                  class=" btn btn-danger"><i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
  </template>
  
  <script lang="ts">
    import { defineComponent, onMounted, ref} from 'vue';
    import { Form, Field, ErrorMessage } from 'vee-validate';
    import * as Yup from 'yup';
    import axios from 'axios';
    import ApiService from '@/services/ApiService';
    import { error, success } from '@/utils/utils';
    import { useRouter, useRoute } from 'vue-router';
    import { Fournisseur } from '@/models/Fournisseur';
    import Multiselect from '@vueform/multiselect/src/Multiselect';
    import 'vue3-tel-input/dist/vue3-tel-input.css'
    import { VueTelInput } from 'vue3-tel-input'
import { formatDate } from '@fullcalendar/core';

  
  export default defineComponent({
      name: "EditFournisseur",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect,
      VueTelInput
      
  },
  
  setup: () => {

    const currentDate = ref(new Date().toISOString().split('T')[0]);
    
      const fournisseurSchema = Yup.object().shape({
      nomFournisseur: Yup.string().when([], (value, schema) => {
        return showAdditionalFields.value
          ? schema.required("Le nom du fournisseur est obligatoire")
          : schema.notRequired()
      }),
      prenomFournisseur: Yup.string().when([], (value, schema) => {
        return showAdditionalFields.value
          ? schema.required("Le prénom du fournisseur est obligatoire")
          : schema.notRequired()
      }),
      sexe: Yup.string().when([], (value, schema) => {
        return showAdditionalFields.value
          ? schema.required("Le sexe est obligatoire")
          : schema.notRequired()
      }),
      raisonSociale: Yup.string().when([], (value, schema) => {
        return !showAdditionalFields.value
          ? schema.required("La raison sociale est obligatoire")
          : schema.notRequired()
      }),
      rccm: Yup.string().when([], (value, schema) => {
        return !showAdditionalFields.value
          ? schema.required("Le rccm est obligatoire")
          : schema.notRequired()
      }),
      dateCreation: Yup.date().when([], (value, schema) => {
        return !showAdditionalFields.value
          ? schema.notRequired()
          : schema.notRequired()
    }),
       
    ifu: Yup.string().matches(/^\d{13}$/, 'La saisie doit avoir exactement 13 chiffres').when([], (value, schema) => {
        return !showAdditionalFields.value
          ? schema.min(13,"La saisie doit avoir exactement 13 chiffres").max(13, "La saisie doit avoir exactement 13 chiffres").required('L\'ifu est obligatoire')
          : schema.min(13,"La saisie doit avoir exactement 13 chiffres").max(13, "La saisie doit avoir exactement 13 chiffres")
      }),
      adresseFournisseur: Yup.string().notRequired(),
      email: Yup.string().email("Veuillez entrer un mail valide").notRequired(),
      telFournisseur1: Yup.string().typeError('Veuillez entrer des chiffres').required('Le telephone 1 est obligatoire'),
      telFournisseur2: Yup.string().typeError('Veuillez entrer des chiffres').notRequired(),
      // ifu: Yup.number().typeError('Veuillez entrer des chiffres').required('L\'ifu est obligatoire'),
      sigle: Yup.string().notRequired(),
      denomination: Yup.string().notRequired(),
      statut: Yup.string().required('Le statut est obligatoire'),

    });

    onMounted(() => {
      if(route.params.id) {
        getFournisseur(parseInt(route.params.id as string));
      }
    });

    //const router = useRouter();
    const defaultStatut = ref(1);
    const showAdditionalFields = ref(null);

    const  codepay= ref();
    const  nationalnumlber= ref();
    const telephone=ref();
    const telFournisseur2=ref();
    const validPhone=ref<boolean>(false);
    const numberPhone=ref();

    const isDisable = ref(true);
    const valuess = ref();
    const router = useRouter();
    const fournisseurForm = ref<Fournisseur>();
    const route = useRoute();
    const showMErr = ref(false);
    const types = ref();

    function validate(phoneObject) {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid == true) {
        telephone.value = phoneObject.number;
        telFournisseur2.value = phoneObject.number;
        codepay.value= phoneObject.countryCallingCode;
        nationalnumlber.value = phoneObject.nationalNumber;
        numberPhone.value = phoneObject.nationalNumber;

      }else{
        telephone.value="";
        telFournisseur2.value="";
        codepay.value= "";
        nationalnumlber.value= "";
        numberPhone.value="";
      }
    }


    const handleObjetInput = (selectedValue) => {
      showAdditionalFields.value = selectedValue === 1;
    }

    const statut = 
      [
      {
          value: 1 ,
          label: "Personne physique"
      },
      {
          value: 2 ,
          label: "Personne Morale"
      }
    ];
   


  function getFournisseur(id: number) {

  ApiService.get("/fournisseurs/" + id.toString())
    .then(({ data }) => {
      for (const key in data.data) {
        console.log("je suis iciiii", data.data)
        let value = data.data[key];
        if(key=="ifu"){
          fournisseurForm.value?.setFieldValue(key,
          value == null ? null : value
        );
        }
        else if(key=='dateCreation'){
          fournisseurForm.value?.setFieldValue(
          key,
          value ? value.split('T')[0] : null
        );
        }
        else {
          fournisseurForm.value?.setFieldValue(
          key,
          typeof value === 'object' && value !== null ? value.id : value
        );
        }
        
      }
      showAdditionalFields.value=(data.data.statut==1)? true:false
    })
    .catch(({ response }) => {
      error(response.message);
    });
}
   
    const editFournisseur = async (values, {resetForm}) => {
      console.log("Formulaire soumis avec :", values);
      ApiService.put("/fournisseurs/"+values.id,values)
        .then(({ data }) => {
          console.log('valeur',data);
          if(data.code == 200) { 
            success(data.message);
            resetForm();
            router.push({ name: "ListeFournisseur" });

          }
        }).catch(({ response }) => {
          error(response.data.message);
      });
    };

   
  
   
      return {fournisseurForm,statut,
        isDisable,
        valuess,
         fournisseurSchema,
          editFournisseur,
          showMErr,
        validPhone,
        validate,
          types,
          showAdditionalFields,
        handleObjetInput,
        currentDate,
        formatDate,
        defaultStatut,
         
          
        };
    },
  });
  </script>
  <style scoped>
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .marge-droite {
    margin-left: 15px;
  }
  .hr-longeur {
    width: 80%;
  }
  .bord1 {
    border: 1px solid #07a;
  }
  .fond {
    background-color: rgb(94, 191, 233);
  }
  </style>
  